import { Params, matchPath } from "react-router-dom";
import { AUTH_ROUTE_PATHS, AUTH_ROUTE_PATHS_ARRAY } from "../../routing/AuthenticationRoutes";
import { ERROR_ROUTE_PATHS } from "../../routing/ErrorRoutes";
import {
  INNER_ROUTE_SHOW_PERIOD_SELECTOR,
  ROUTES_WITHOUT_PERIOD_SELECTOR,
  ROUTES_WITHOUT_PERIOD_SELECTOR_IGNORE_HASH,
} from "../constants/routing-constants";
import { ANNUAL_INCENTIVES_PATHNAMES, ROUTE_PATHS } from "../enums/routing-enums";

const ERR_ROUTES_ARRAY = Object.values(ERROR_ROUTE_PATHS);

export const isAuthRoute = (pathname: string) => {
  return AUTH_ROUTE_PATHS_ARRAY.some((route) => {
    // Use matchPath to handle parameterized routes like /message/:code
    return matchPath(route, pathname) !== null;
  });
};

export const isErrorRoute = (pathname: string) => {
  return ERR_ROUTES_ARRAY.some((route) => route === pathname);
};

export const isAuthOrErrorRoute = (pathname: string) => {
  return isAuthRoute(pathname) || isErrorRoute(pathname);
};

export const isUrlIncludesRoutes = (option = "") => {
  let routes: string[];
  switch (option) {
    case "error":
      routes = [...ERR_ROUTES_ARRAY];
      break;
    case "auth":
      routes = [...AUTH_ROUTE_PATHS_ARRAY];
      break;
    default:
      routes = [...AUTH_ROUTE_PATHS_ARRAY, ...ERR_ROUTES_ARRAY];
      break;
  }

  return routes.some((path) => window.location.href.includes(path));
};

export const chatbotPath = (pathname: string) => {
  return (
    pathname !== "/impersonation.html" && pathname !== "/jwt-receiver.html" && pathname !== "/entra-jwt-token.html"
  );
};

export const getKeyByValue = (value: string): string | undefined => {
  const keys = Object.keys(ROUTE_PATHS) as Array<keyof typeof ROUTE_PATHS>;
  for (const key of keys) {
    if (ROUTE_PATHS[key] === value) {
      return key.toLowerCase();
    }
  }
  return undefined;
};

export const innerPathnameLogic = (pathname: string, type: string) => {
  switch (type) {
    case "edlos":
      return INNER_ROUTE_SHOW_PERIOD_SELECTOR.includes(pathname);
    case "hat":
      return ([ROUTE_PATHS.HAT_QC_DETAILS, ROUTE_PATHS.HAT_ABO_TRACKING] as string[]).includes(pathname);
    default:
      return false;
  }
};

export const periodSelectorRoutes = (
  pathToCheck: string,
  removalRoutes: string[],
  urlParams: Readonly<Params<string>>,
  hash = "",
) => {
  const routes = [...ROUTES_WITHOUT_PERIOD_SELECTOR, ...removalRoutes];

  // handle dynamic routes
  if (urlParams["abo"]) {
    pathToCheck = pathToCheck.replace(urlParams["abo"], ":abo");
  }

  const fullPath = hash ? `${pathToCheck}${hash}` : pathToCheck;
  return !routes.includes(fullPath) && !ROUTES_WITHOUT_PERIOD_SELECTOR_IGNORE_HASH.includes(pathToCheck);
};

export const tealiumTracking = (pathname: string) => {
  const routesWithNoTealiumTracking: string[] = [
    AUTH_ROUTE_PATHS.AMWAY_ID_LOGIN,
    AUTH_ROUTE_PATHS.AMWAY_ID_JWT_TOKEN,
    AUTH_ROUTE_PATHS.IMPERSONATE,
    AUTH_ROUTE_PATHS.JWT_RECEIVER,
    AUTH_ROUTE_PATHS.TOKEN_RECEIVER,
    AUTH_ROUTE_PATHS.IMPERSONATION,
  ];
  return routesWithNoTealiumTracking.includes(pathname);
};

export const isAnnualIncentive = (pathname: string): boolean => {
  return ANNUAL_INCENTIVES_PATHNAMES.includes(pathname);
};
